import { styled } from '@mui/material/styles';

// useLayoutSize 의 APPROVAL/DEFAULT maxMobileWidth 와 동일 기준
const MOBILE = '@media (max-width: 769px)';

export const ReasonBody = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${MOBILE} {
    gap: 24px;
  }
`;

export const ReasonField = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReasonTextarea = styled('textarea')`
  width: 100%;
  height: 152px;
  padding: 16px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #000);
  box-sizing: border-box;

  &::placeholder {
    color: var(--dk-text-dim, #b7bbc2);
  }

  &:focus {
    outline: 0;
    border-color: #000;
  }
`;

/**
 * 사유 글자수 카운터 — 입력창 우측 하단. 상한을 하드로 막으므로 초과 상태(경고색)는 없다.
 * 붙여넣기로 잘리는 경우가 있어, 지금 몇 자인지는 항상 보여 준다.
 */
export const ReasonCharCount = styled('div')`
  align-self: flex-end;
  font-size: 12px;
  line-height: 16px;
  color: var(--dk-text-secondary, #888d96);
`;

export const ReasonFooter = styled('div')`
  display: flex;
  gap: 8px;

  > button {
    flex: 1;
  }
`;

export const reasonModalSx = {
  '& .modal-inner.x-small': {
    // 입력~버튼 간격은 푸터 상단 여백이 전담
    '& .modal-body': { paddingBottom: 0 },
    '& .modal-footer': { padding: '24px 20px 20px', backgroundColor: 'var(--dk-bg, #fff)' },

    [MOBILE]: {
      top: 'auto',
      bottom: 0,
      left: 0,
      transform: 'none',
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      borderRadius: '20px 20px 0 0',

      '& .modal-header': {
        minHeight: '56px',
        padding: '4px 16px',
        backgroundColor: 'var(--dk-bg, #fff)',
        backdropFilter: 'none',
        borderRadius: '20px 20px 0 0',
        // 닫기 버튼(36px)과 대칭인 스페이서 — 타이틀 정중앙 정렬용
        '&::before': { content: '""', flexShrink: 0, width: '36px' },
        '& h1': {
          flex: 1,
          justifyContent: 'center',
          fontWeight: 400,
          // 공유 Modal 이 인라인 style 로 박는 값이라 !important 필요
          paddingLeft: '0 !important',
        },
      },
      '& .modal-body': { padding: '24px 20px 32px' },
      '& .modal-footer': {
        padding: '12px 20px',
        backgroundColor: 'var(--dk-bg-muted, #f3f5f6)',
        borderTop: '1px solid var(--dk-line, #e7e9ec)',
        borderRadius: 0,
      },
    },
  },
};
